<template>
  <div class="login">
    <div class="login-bgc-top">
      <img src="@/assets/image/login/bgc-top-l.png" />
    </div>

    <div class="FormSubmit">
      <van-form ref="form" @submit="onSubmit">
        <van-field class="iconfont icon-shoujihao1" v-model="tel" type="tel" clearable name="tel" :rules="userTel"
          placeholder="请输入手机号" />
        <van-field class="iconfont icon-shoujihao1" v-model="pass" type="password" clearable :rules="password"
          placeholder="请输入密码" />
        <!-- <van-field
          v-model="sms"
          center
          ref="yanzhengCode"
          :rules="userMsg"
          clearable
          class="iconfont icon-yanzhengyanzhengma"
          placeholder="请输入手机验证码"
          type="digit"
        >
          <template #button>
            <van-button
              type="primary"
              size="small"
              class="getCode"
              @click="sendCode"
              :disabled="ifdisabled"
              native-type="button"
            >
              {{ codeMsg }}
            </van-button>
          </template>  
        </van-field> -->
        <div class="login-btn">
          <van-button block type="primary" native-type="submit"><span style="fontsize: px">登&nbsp;录</span>
          </van-button>
        </div>
        <div class="text-box">
          <div class="text-box-no">没有帐号？</div>
          <div class="text-box-go" @click="$router.push('register')">
            立即注册
          </div>
          <div class="text-box-paws" @click="$router.push('password')">
            忘记密码
          </div>
        </div>
      </van-form>
    </div>

    <!-- <div class="login-bgc-bottom">
      <img src="@/assets/image/login/bgc-bottom.png">
    </div> -->
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      tel: "",
      sms: "",
      pass: "",
      ifdisabled: false,
      codeNum: 60,
      codeMsg: "获取验证码",
      count: "",
      userTel: [
        {
          required: true,
          message: "请输入手机号",
          trigger: "onBlur",
        },
        {
          validator: (value) => {
            return /^1[23456789]\d{9}$/.test(value);
          },
          message: "手机号格式错误，请检查！",
        },
      ],
      password: [
        {
          required: true,
          message: "请输入密码",
          trigger: "onBlur",
        },
      ],

      userMsg: [
        {
          required: true,
          message: "请输入验证码",
          trigger: "onBlur",
        },
        {
          validator: (value) => {
            // return /^\d{6}$/.test(value);
          },
          message: "验证码格式错误，请检查！",
        },
      ],
    };
  },
  methods: {
    // 获取短信验证码
    async sendCode() {
      // 验证手机号格式是否正确
      if (!this.tel) {
        this.$toast("请输入手机号！");
        return;
      }
      if (!this.userTel[1].validator(this.tel)) return;
      //发送请求
      const { data: data } = await this.$http.post("system/sms", {
        phone: this.tel,
        type: "LOGIN",
      });
      if (data.code === 200) {
        this.$toast("验证码已发送！");
        // 禁用按钮
        this.ifdisabled = true;
        // 倒计时
        this.count = this.codeNum;
        let timer = setInterval(() => {
          if (this.count > 1 && this.count <= this.codeNum) {
            this.count--;
            this.codeMsg = `重新发送(${this.count})`;
          } else {
            // 判断什么时候停止定时器
            clearInterval(timer);
            this.codeMsg = "获取验证码";
            this.ifdisabled = false;
            this.count = "";
          }
        }, 1000);
      } else {
        this.$toast(data.message);
      }
    },
    //登录
    async onSubmit() {
      // this.$toast("项目时间未开始，敬请期待");
      // return
      const { data: data } = await this.$http.post("auth/login", {
        username: this.tel, //手机号
        password: this.pass, //验证码
      });
      if (data.code == 200) {
        localStorage.setItem("token", data.data.access_token);
        this.getMeApi();
      }
    },
    //获取用户信息 判断是否认证
    async getMeApi() {
      const { data: data } = await this.$http.post("auth/me");
      localStorage.setItem("information", JSON.stringify(data.data));
      if (data.data.doctor_status == 0) {
        this.$router.push("certification");
      } else {
        this.$toast(data.message);
        this.$router.push("/homeTopic");
        window.location.reload();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.login {
  height: 100vh;
  position: relative;
  overflow: hidden;

  .login-bgc-top {
    position: relative;
    top: 0;
    left: 0;
    width: 306px;
    height: 241px;
  }

  .van-field__control {
    font-size: 16px;
    margin-left: 15px;
  }

  .situLogo {
    margin: 40px auto;
    width: 218px;
    height: 108px;
  }

  .getCode {
    // border-radius: 10px;
    background-color: #ea260e;
    border: 0.02667rem solid #ea260e;
    background: linear-gradient(90deg, #ea260e 0%, #f86b05 100%) !important;
  }

  .FormSubmit {
    margin-top: 10px;
  }

  .login-btn {
    margin-top: 50px;
    padding: 0 30px;

    /deep/ .van-button--primary {
      background-color: #04b5c4;
      border: 0.02667rem solid #04b5c4;
      background: #04b5c4 !important;
    }
  }

  .footCar {
    position: fixed;
    bottom: 0px;
    right: 0px;
  }

  .text-box {
    display: flex;
    padding: 0 30px;
    justify-content: flex-end;
    margin-top: 13px;
    font-size: 13px;

    .text-box-go {
      color: #ef3f0b;
    }

    .text-box-no {
      color: #333;
    }
  }

  .login-bgc-bottom {
    // position: relative;
    // bottom: -4px;
    // right: 0px;

    position: fixed;
    bottom: -4px;
    right: 0px;
    width: 100%;
    // height: 109px;
  }

  .text-box-paws {
    color: blue;
    margin-left: 10px;
  }
}
</style>
